import { render, staticRenderFns } from "./HidePromoButton.vue?vue&type=template&id=229d3d96&scoped=true"
import script from "./HidePromoButton.vue?vue&type=script&lang=js"
export * from "./HidePromoButton.vue?vue&type=script&lang=js"
import style0 from "./HidePromoButton.vue?vue&type=style&index=0&id=229d3d96&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "229d3d96",
  null
  
)

export default component.exports